import axios from "axios";

export const getEventById = (eventId) => {
  return axios.get(
      process.env.REACT_APP_FETCH_URL + "/event_by_id/" + eventId
  );
} 
